import { useEffect, useRef } from "react"
import { useAppDispatch } from "../store/hooks"
import { v4 as uuidv4 } from "uuid"
import { actions } from "../store/app/slice"

function useOmniLoader(isLoading: boolean, condition?: boolean, isShow = true) {
    const dispatch = useAppDispatch()
    const processId = useRef(uuidv4())

    useEffect(() => {
        if (isShow && (condition === undefined || condition)) {
            dispatch(actions[isLoading ? "addProcess" : "removeProcess"](processId.current))
        }

        return () => {
            if (isLoading) {
                dispatch(actions.removeProcess(processId.current))
            }
        }
    }, [condition, isLoading])
}

export default useOmniLoader
